import {
  updateAsset,
} from '../../store/slices/assetsSlice';

export function createSectionHandlers({
  dispatch,
  sectionTitleTimersRef,
}) {
  const handleSectionTitleChange = (assetId, newTitle) => {
    // Clear existing timer for this asset
    if (sectionTitleTimersRef.current[assetId]) {
      clearTimeout(sectionTitleTimersRef.current[assetId]);
    }

    // Update Redux immediately (optimistic UI)
    dispatch({
      ...updateAsset({
        id: assetId,
        changes: { name: newTitle },
      }),
      meta: { undoable: true },
    });

    // Debounce for 1500ms (like legacy editor)
    // eslint-disable-next-line no-param-reassign
    sectionTitleTimersRef.current[assetId] = setTimeout(() => {
      // Redux is already updated, no additional action needed
      // Backend persistence will happen in publish.js
      // eslint-disable-next-line no-param-reassign
      delete sectionTitleTimersRef.current[assetId];
    }, 1500);
  };

  return {
    handleSectionTitleChange,
  };
}

